import {msg} from '@lingui/core/macro'
import {useLingui} from '@lingui/react'

import {useTheme} from '#/alf'
import {CircleInfo_Stroke2_Corner0_Rounded as CircleInfo} from '#/components/icons/CircleInfo'
import * as Pills from '#/components/Pills'
import * as Prompt from '#/components/Prompt'

/**
 * Pill shown on posts where the Bluesky Moderation Service applied an adult
 * content label the author didn't self-disclose. Gated behind
 * `UNDISCLOSED_ADULT_CONTENT_BADGE_ENABLED` by the caller.
 */
export function UndisclosedAdultContentPill({
  size,
}: {
  size?: Pills.CommonProps['size']
}) {
  const t = useTheme()
  const {_} = useLingui()
  const control = Prompt.usePromptControl()

  return (
    <>
      <Pills.LabelBase
        label={_(
          msg`Moderators flagged adult content the author didn't disclose`,
        )}
        cta={_(msg`Potentially Undisclosed NSFW`)}
        size={size}
        noBg={size === 'sm'}
        icon={
          <CircleInfo
            width={size === 'lg' ? 16 : 12}
            fill={t.palette.negative_500}
          />
        }
        onPress={() => control.open()}
      />
      <Prompt.Basic
        control={control}
        title={_(msg`Potentially undisclosed adult content`)}
        description={_(
          msg`The Bluesky Moderation Service flagged this post as containing adult content, but the author may not have marked it with a content warning.`,
        )}
        confirmButtonCta={_(msg`Got it`)}
        onConfirm={() => {}}
        showCancel={false}
      />
    </>
  )
}
